<template>
  <div class="register container">
    <PageHeading heading="Insert Results"/>
    <br/>
    <p v-if="success_message != null">Success: {{success_message.message}}</p>
    <form class="row" ref="form">
      <!-- BEGIN FIRST COLUMN OF FORM -->
      <div class="col-md-12 team">
        <div class="row g-3">
          <!-- Date -->
          <div class="col-md-6">
            <label for="date" class="form-label">Date <span class="red" v-if="required(this.date)">(REQUIRED)</span></label>
            <select id="date" class="form-select" v-model="date">
              <option disabled value="">Select a date</option>
              <option v-for="date in dates" :key="date.id" :value="date.date">{{fmtDate(date.date)}} at {{date.location}}</option>
            </select>
          </div>
          <!-- Division-->
          <div class="col-md-6">
            <label for="division" class="form-label">Division <span class="red" v-if="required(division)">(REQUIRED)</span></label>
            <select id="division" class="form-select" v-model="division" :class="required(division)">
              <option value="">Select a division</option>
              <option>Novice</option>
              <option>Intermediate</option>
              <option>Expert</option>
            </select>
          </div>
          <!-- Data -->
          <div class="col-md-12">
            <label for="data" class="form-label">RESULTS (CSV) <span>(REQUIRED)</span></label>
            <textarea class="form-control" id="data"  v-model="data" :rows="parsedResults.length"></textarea>
          </div>
          <div class="row" v-if="this.parsedResults.length >= 1 ">
      <div class="col-12">
        <table class="table table-striped" id="sched">
          <thead>
            <tr>
              <th>Place</th>
              <th>Date</th>
              <th>Division</th>
              <th>Name</th>
              <th>Team Name</th>
              <th>Average</th>
              <th>Errors</th>
              <th>Rounds</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="result in parsedResults" :key="result.id">
              <td>{{result[0]}}</td>
              <td>{{result[1]}}</td>
              <td>{{result[2]}}</td>
              <td>{{result[3]}}</td>
              <td>{{result[4]}}</td>
              <td>{{result[5]}}</td>
              <td>{{result[6]}}</td>
              <td>{{result[7]}}</td>
            </tr>
          </tbody>
        </table> 
      </div>
    </div>
    <!-- Password -->
      <div class="col-md-12">
      <label for="data" class="form-label">Password <span>(REQUIRED)</span> <span>Enter the password once you are sure you're ready to submit.</span></label>
      <input type="text" class="form-control" id="password"  v-model="password"/>
      </div>
    <p v-if="error_message != null && success != null && success == false">Error: {{error_message.error}}</p>
        </div><!-- END ROW OF FIRST COLUMN -->
      </div><!-- END FIRST COLUMN OF FORM-->
    </form>
    <div class="d-grid gap-2">

      <button class="btn btn-dark" type="button" @click="register" v-if="!success" :disabled="!formComplete">Submit</button>
    </div>
    </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios"
import PageHeading from '@/components/PageHeading.vue';

export default {
  name: 'InsertResults',
  components: {
    PageHeading
  },
  data: function() {
    return {
      data: '',
      parsedResults: [],
      division: null,
      success: null,
      date: null,
      dates: [],
      password: null,
      error_message: null,
      success_message: null
    }
  },
  created() {
    // Get the schedule to populate the dates for registration 
    axios.get(process.env.VUE_APP_API_ROOT + "/lib/schedule.php")
    .then((response) => {
      if(response.data !== null) {
        this.dates = response.data.map (a => {return {date: a.date, location: a.location}});
        
        // Find the nearest future date
        // this.date = this.findNearest();
      }
    });

//     this.data =  `1, Noah Wang ECC, Mutual Edification, 75.00, 7, 6
// 2, Abraham Chen, ECC Eats, 71.67, 11, 6
// 3, Desiree McCleskey, Puyallup Purely Puzzled, 66.67, 2, 6
// 4, Leon Chen, ECC Mutual Edification, 55.00, 4, 6
// 5, Larry Zhang, ECC Eats, 55.00, 10, 6
// 6, Calvin Zhou, ECC Drinks, 53.33, 9, 6
// 7, Irene Chen, ECC Drinks, 30.00, 10, 6
// 8, Devon McCleskey, Puyallup Purely Puzzled, 26.67, 5, 6
// 9, Emily Xin, ECC Drinks, 23.33, 1, 6
// 10, Michael Cramer, ECC Mutual Edification, 6.67, 5, 6
// 11, Andy Pan, ECC Drinks, 0.00, 0, 6
// 12, Josiah Kim-George, ECC Eats, 0.00, 3, 6
// 13, Alice Guo, Puyallup Purely Puzzled, 0.00, 3, 6`;

  },
  computed: {
    formComplete: function() {
      return this.isNotBlank(this.date) && this.isNotBlank(this.division) && this.isNotBlank(this.parsedResults) && this.parsedResults.length > 0 && this.parsedResults[0].length == 8 && this.isNotBlank(this.password);
    }
  },
  methods: {
    isNotBlank: function(val) {
      return val && val.length > 0 ? true:false;
    },
    required: function(val) {
      return val == "" || val == "is-invalid" ? true : false;
    },
    findNearest: function() {
      let now = new Date();
      // first set nearest date after 'now'
      let nearest = undefined;
      this.dates.forEach(function(d) {
       const date = new Date(d.date);
       if (date >= now) {
          nearest = d.date;
          now = new Date("2100-01-01");
        }
      })
      return nearest;
    },
    resetForm: function() {
      this.data = '',
      this.parsedResults.splice(0),
      this.division = null,
      this.success = false,
      this.date = null,
      this.password = null,
      this.error_message = null
    },
    parseResults: function(newData) {
      const rows = newData.split(/\r?\n/);
      this.parsedResults = [];
      for (let i = 0; i < rows.length; i++) {
        let row = rows[i].split(",");
        row.splice(1, 0, this.date);
        row.splice(2, 0, this.division);
        this.parsedResults.push(row);
      }

    },
    register: function() {
      const formData = {results: this.parsedResults, password: this.password};
     
      axios.post(process.env.VUE_APP_API_ROOT + '/lib/save_scores.php', formData)
                .then((res) => {
                  res;
                    this.success = true;
                    this.resetForm();
                    this.success_message = JSON.parse(res.data);
                })
                .catch((error) => {
                  this.success = false;
                  this.success_message = null;
                  this.error_message = JSON.parse(error.response.data);
                  console.log(this.error_message.error);
                });
      
    }
  },
  watch: {
    data() {
      this.parseResults(this.data);
    },
    division() {
      this.parseResults(this.data);
    },
    date() {
      this.parseResults(this.data);
    },
    parsedResults(newVal) {
      if(newVal.length == 1 && newVal[0].length == 3 && newVal[0][0] == "" && newVal[0][1] == null && newVal[0][2] == null ) {
        this.parsedResults.splice(0);
      }
      
    }
  }
}
</script>

<style>
label > span {
  font-size: 75%;
  color: rgb(122, 122, 122)
}
.red {
  color: rgb(155, 0, 0);
  font-weight: bold;
}
form  {
  padding: 0 1em;
}

.quizzer {

  border-radius: 5px;
  background-color: #FBFBFB;
  padding: .5em;
  margin: 1em auto;
}

.quizzers {
  padding-top: .5em;
  background-color: #F9F9F9;
  margin-bottom: 1em;
}

.team {
  padding-top: 1em;
  background-color: #FBFBFB;
  border-right: 2px dotted #DADADA; margin-bottom: 1em;
}

.confirmation {
  margin: 1em 0;
}

.confirmation .container {
  padding-left: .5em;
} 
</style>